import { memo } from 'react';

import { Select } from 'antd';

import AppModal from '../../../components/AppModal';

const ChooseGeofencesModal = ({ isOpen, onCancel, handleGeofenceChange, onSave, value = {}, options = [] }) => {
  return (
    <AppModal isOpen={isOpen} confirmButtonText="Save" title="Pastures" handleCancel={onCancel} handleConfirm={onSave}>
      <div className="py-4">
        <Select
          className="w-full"
          optionFilterProp="label"
          options={options}
          showSearch={true}
          value={value}
          onChange={handleGeofenceChange}
        />
      </div>
    </AppModal>
  );
};

export default memo(ChooseGeofencesModal);
